import { render, staticRenderFns } from "./Drills.vue?vue&type=template&id=13571b0f&scoped=true&"
import script from "./Drills.vue?vue&type=script&lang=js&"
export * from "./Drills.vue?vue&type=script&lang=js&"
import style0 from "./Drills.vue?vue&type=style&index=0&id=13571b0f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13571b0f",
  null
  
)

component.options.__file = "Drills.vue"
export default component.exports